exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* purgecss start ignore */\n.no-request-message[data-v-5a3095f5] {\n  text-align: left;\n  font-size: 13px;\n  color: #666;\n  padding: 45px 20px 5px 20px;\n}\n\n/* purgecss end ignore */\n", ""]);

// exports
